import React from 'react';
import { useSelector } from 'react-redux';
import { selectMoldReceivingFilterVisible, selectTileView } from './store/selectors'; // Import the selector
import MoldMaintenanceSearch from './mold-maintenance-search';
import MoldMaintenanceFilter from './mold-maintenance-filter';
import MoldMaintenanceTile from './mold-maintenance-tile';
import MoldMaintenanceTable from './mold-maintenance-table';

const MoldMaintenanceContent = () => {
  const isFilterVisible = useSelector(selectMoldReceivingFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector
  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top mold-maint-table-top">
          <MoldMaintenanceSearch />
        </div>
        {isFilterVisible && <MoldMaintenanceFilter />}

        {!showTileView ? <MoldMaintenanceTile  /> : <MoldMaintenanceTable />}
      </div>
    </div>
  );
};

export default MoldMaintenanceContent;
